import React from "react";
import Button from "../components/buttons/Button";
import Social from "../components/socials/Social";
import Text from "../components/typography/Text";

// Logos
import EPFLSVG from "../images/logos/epfl_logo_grey.svg";
import ECALSVG from "../images/logos/ecal_logo_grey.svg";
import LASOURCE from "../images/logos/la_source_logo_grey.svg";
import GRSSVG from "../images/logos/GRS_logo.svg";
import HEIG from "../images/logos/HEIG.png";
import VAUD from "../images/logos/Vaud.png";
import UNIL from "../images/logos/Unil.png";
import EHL from "../images/logos/ehl.png";

// Get Copyright date
const months = [
	"January",
	"February",
	"March",
	"April",
	"May",
	"June",
	"July",
	"August",
	"September",
	"October",
	"November",
	"December",
];
const now = new Date();
const month = months[now.getMonth()];
const year = now.getFullYear();
const date = `${month} ${year}`;

export default () => {
	return (
		<div className="oFooter">
			<div className="oFooter_line -contained">
				<div className="oFooter_contact">
					<h4>Do you have a question ?</h4>
					<Button
						icon="send"
						rounded
						onClick={() =>
							window.open("mailto:info@enabledbydesign.ch", "_blank")
						}
					>
						Contact us
					</Button>
				</div>

				<div className="oFooter_support">
					<div className="oFooter_block">
						<Text small>Led by</Text>
						<div className="oFooter_logos" style={{ marginTop: 20 }}>
							<a
								href="https://www.epfl.ch/"
								target="_blank"
								rel="noopener noreferrer"
							>
								<img src={EPFLSVG} alt="EPFL" height="21.6px" />
							</a>
							<a
								href="https://www.ecal.ch"
								target="_blank"
								rel="noopener noreferrer"
							>
								<img src={ECALSVG} alt="ECAL" height="25.2px" />
							</a>
						</div>
					</div>
					<div className="oFooter_block">
						<Text small>Partners</Text>
						<div className="oFooter_logos" style={{ marginTop: "20px" }}>
							<a
								href="https://www.vd.ch/"
								target="_blank"
								rel="noopener noreferrer"
							>
								<img src={VAUD} alt="VAUD" height="40px" />
							</a>
							<a
								href="https://www.grstiftung.ch/"
								target="_blank"
								rel="noopener noreferrer"
							>
								<img
									src={GRSSVG}
									alt="GRS"
									height="31.2px"
									style={{ marginLeft: "3px", marginTop: "6px" }}
								/>
							</a>
						</div>
						<div className="oFooter_logos" style={{ marginTop: "20px" }}>
							<a
								href="https://www.unil.ch/"
								target="_blank"
								rel="noopener noreferrer"
							>
								<img
									src={UNIL}
									alt="UNIL"
									height="40px"
									style={{ marginRight: "10px" }}
								/>
							</a>
							<a
								href="https://heig-vd.ch/"
								target="_blank"
								rel="noopener noreferrer"
							>
								<img src={HEIG} alt="HEIG VD" height="40px" />
							</a>
						</div>
						<div className="oFooter_logos" style={{ marginTop: "20px" }}>
							<a
								href="https://www.ehl.edu"
								target="_blank"
								rel="noopener noreferrer"
							>
								<img
									src={EHL}
									alt="EHL"
									height="40px"
									style={{ marginRight: "25px" }}
								/>
							</a>
							<a
								href="https://www.h4vd.ch/"
								target="_blank"
								rel="noopener noreferrer"
							>
								<img
									src={LASOURCE}
									alt="H4VD"
									height="25px"
									style={{ marginRight: "10px", marginTop: "3px" }}
								/>
							</a>
						</div>
					</div>
				</div>
			</div>
			<div className="oFooter_line -contained">
				<div className="oFooter_follow">
					<div className="oFooter_socials">
						<Social href="https://medium.com/@enabledbydesign" icon="medium">
							Medium
						</Social>
					</div>
				</div>
				<div className="oFooter_copyright">
					<Text small>Copyright © {date}</Text>
				</div>
			</div>
		</div>
	);
};
